import React, {useEffect, useState} from 'react';
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Collapse,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fab,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    LinearProgress,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Paper,
    Rating,
    Select,
    Skeleton,
    Snackbar,
    Step,
    StepConnector,
    stepConnectorClasses,
    StepLabel,
    Stepper,
    styled,
    Switch,
    Tab,
    Tabs,
    TextField,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import {
    AccountBalance,
    Add,
    Apartment,
    Assignment,
    AttachMoney,
    Bookmark,
    BookmarkBorder,
    Business,
    CalendarToday,
    CheckCircle,
    ChevronLeft,
    Delete as DeleteIcon,
    Description,
    EmojiEvents,
    ExpandLess,
    ExpandMore,
    FilterAlt,
    GridView,
    Group,
    Info,
    LocationOn,
    Refresh,
    School,
    Star,
    ViewList
} from '@mui/icons-material';

const QontoConnector = styled(StepConnector)(({theme}) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const ScholarShip = () => {
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedClass, setSelectedClass] = useState('all');
    const [selectedAmount, setSelectedAmount] = useState('all');
    const [sortBy, setSortBy] = useState('deadline');
    const [viewMode, setViewMode] = useState('grid');
    const [tabValue, setTabValue] = useState(0);
    const [applicationDialog, setApplicationDialog] = useState(false);
    const [selectedScholarship, setSelectedScholarship] = useState(null);
    const [bookmarkedScholarships, setBookmarkedScholarships] = useState(new Set());
    const [applicationStep, setApplicationStep] = useState(0);
    const [applicationData, setApplicationData] = useState({
        studentName: '',
        studentId: '',
        class: '',
        parentIncome: '',
        reason: '',
        documents: [],
        guardianName: '',
        guardianPhone: '',
        guardianEmail: '',
        address: '',
        previousScholarships: '',
        achievements: '',
        financialNeed: ''
    });
    const [snackbar, setSnackbar] = useState({open: false, message: '', severity: 'success'});
    const [appliedScholarships, setAppliedScholarships] = useState(new Set());
    const [showFilters, setShowFilters] = useState(true);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [quickApplyDialog, setQuickApplyDialog] = useState(false);
    const [detailsView, setDetailsView] = useState(false);

    // New states for scholarship creation
    const [isAdmin, setIsAdmin] = useState(false); // Toggle between admin/student view
    const [createScholarshipDialog, setCreateScholarshipDialog] = useState(false);
    const [newScholarship, setNewScholarship] = useState({
        name: '',
        category: 'class',
        type: 'Class-based',
        class: '',
        amount: '',
        eligibility: '',
        openDate: '',
        closeDate: '',
        description: '',
        provider: '',
        requirements: [''],
        status: 'active',
        rating: 4.5,
        applicants: 0,
        awarded: 0,
        trending: false,
        featured: false,
        contact: ''
    });
    const [applicationsList, setApplicationsList] = useState([]); // For viewing applications as admin

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const userDetails = {
        name: 'John Doe',
        id: 'ST001',
        class: '10',
        schoolId: 'SCH001',
        session: '2024-25'
    };

    const classOptions = [
        {value: 'kg', label: 'Kindergarten'},
        {value: '1', label: 'Class 1'},
        {value: '2', label: 'Class 2'},
        {value: '3', label: 'Class 3'},
        {value: '4', label: 'Class 4'},
        {value: '5', label: 'Class 5'},
        {value: '6', label: 'Class 6'},
        {value: '7', label: 'Class 7'},
        {value: '8', label: 'Class 8'},
        {value: '9', label: 'Class 9'},
        {value: '10', label: 'Class 10'},
        {value: '11', label: 'Class 11'},
        {value: '12', label: 'Class 12'}
    ];

    const sampleScholarships = [
        {
            id: 1,
            name: 'Early Childhood Excellence Award',
            category: 'class',
            type: 'Class-based',
            class: 'kg,1,2,3',
            amount: '₹10,000',
            eligibility: 'Students showing exceptional early learning skills',
            openDate: '2024-01-15',
            closeDate: '2025-12-15',
            description: 'Encouraging young minds with early academic recognition. This scholarship aims to foster a love for learning from a young age and provide financial assistance to deserving students.',
            provider: 'Early Learning Foundation',
            requirements: ['Parent recommendation', 'Learning assessment', 'Activity portfolio'],
            status: 'active',
            rating: 4.8,
            applicants: 150,
            awarded: 25,
            trending: true,
            featured: true,
            contact: 'contact@earlylearning.org'
        },
        {
            id: 2,
            name: 'Primary Education Support Grant',
            category: 'central',
            type: 'Central Government',
            class: '1,2,3,4,5',
            amount: '₹15,000',
            eligibility: 'Students from economically weaker sections',
            openDate: '2024-02-01',
            closeDate: '2025-12-30',
            description: 'Supporting primary education for underprivileged children. A central government initiative to ensure that every child has access to quality education.',
            provider: 'Ministry of Education',
            requirements: ['Income certificate', 'School enrollment proof', 'Guardian identity'],
            status: 'active',
            rating: 4.7,
            applicants: 2500,
            awarded: 500,
            trending: false,
            featured: true,
            contact: 'scholarships@education.gov.in'
        },
        {
            id: 3,
            name: 'Middle School Merit Scholarship',
            category: 'state',
            type: 'State/Regional',
            class: '6,7,8',
            amount: '���20,000',
            eligibility: 'Students with 80% or above in previous grade',
            openDate: '2024-01-20',
            closeDate: '2025-11-20',
            description: 'Recognizing academic excellence in middle school. This scholarship is for students who have demonstrated outstanding academic performance.',
            provider: 'State Education Department',
            requirements: ['Academic transcripts', 'Progress report', 'Character certificate'],
            status: 'active',
            rating: 4.6,
            applicants: 1200,
            awarded: 200,
            trending: true,
            featured: false,
            contact: 'info@stateeducation.gov'
        },
        {
            id: 4,
            name: 'High School Leadership Award',
            category: 'community',
            type: 'Community-based',
            class: '9,10,11,12',
            amount: '₹25,000',
            eligibility: 'Students with leadership qualities and community service',
            openDate: '2024-02-10',
            closeDate: '2025-11-10',
            description: 'Fostering leadership skills in high school students through community engagement and financial support.',
            provider: 'Community Leadership Trust',
            requirements: ['Leadership portfolio', 'Community service record', 'Peer recommendations'],
            status: 'active',
            rating: 4.9,
            applicants: 800,
            awarded: 50,
            trending: false,
            featured: true,
            contact: 'awards@communityleadership.org'
        },
        {
            id: 5,
            name: 'Senior Secondary Excellence Grant',
            category: 'private',
            type: 'Private',
            class: '11,12',
            amount: '₹50,000',
            eligibility: 'Students pursuing Science/Commerce with 85%+ marks',
            openDate: '2024-01-01',
            closeDate: '2024-02-28',
            description: 'Supporting academic excellence in senior secondary education, helping students prepare for higher education.',
            provider: 'Excellence Foundation',
            requirements: ['Academic records', 'Stream certificate', 'Future goals essay'],
            status: 'expired',
            rating: 4.8,
            applicants: 3000,
            awarded: 100,
            trending: false,
            featured: false,
            contact: 'grants@excellencefoundation.com'
        }
    ];

    const [scholarships, setScholarships] = useState([]);
    const [filteredScholarships, setFilteredScholarships] = useState([]);

    const applicationSteps = [
        {label: 'Basic Information', description: 'Personal and academic details'},
        {label: 'Guardian Details', description: 'Parent/Guardian information'},
        {label: 'Financial Information', description: 'Income and financial need'},
        {label: 'Documents Upload', description: 'Required documents'},
        {label: 'Review & Submit', description: 'Review all information'}
    ];

    useEffect(() => {
        fetchScholarships();
    }, []);

    const fetchScholarships = () => {
        setLoading(true);
        setTimeout(() => {
            setScholarships(sampleScholarships);
            setFilteredScholarships(sampleScholarships);
            setLoading(false);
        }, 1500);
    };

    useEffect(() => {
        let filtered = scholarships;

        if (searchTerm) {
            filtered = scholarships.filter(scholarship =>
                scholarship.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                scholarship.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                scholarship.provider.toLowerCase().includes(searchTerm.toLowerCase()) ||
                scholarship.type.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (selectedCategory !== 'all') {
            filtered = filtered.filter(scholarship => scholarship.category === selectedCategory);
        }

        if (selectedClass !== 'all') {
            filtered = filtered.filter(scholarship =>
                scholarship.class === 'all' ||
                scholarship.class.split(',').includes(selectedClass)
            );
        }

        if (selectedAmount !== 'all') {
            filtered = filtered.filter(scholarship => {
                const amount = parseInt(scholarship.amount.replace(/[₹,]/g, ''));
                switch (selectedAmount) {
                    case 'low':
                        return amount <= 20000;
                    case 'medium':
                        return amount > 20000 && amount <= 40000;
                    case 'high':
                        return amount > 40000;
                    default:
                        return true;
                }
            });
        }

        switch (tabValue) {
            case 1:
                filtered = filtered.filter(scholarship => scholarship.featured);
                break;
            case 2:
                filtered = filtered.filter(scholarship => scholarship.trending);
                break;
            case 3:
                filtered = filtered.filter(scholarship => appliedScholarships.has(scholarship.id));
                break;
            case 4:
                filtered = filtered.filter(scholarship => bookmarkedScholarships.has(scholarship.id));
                break;
            default:
                break;
        }

        filtered.sort((a, b) => {
            switch (sortBy) {
                case 'deadline':
                    return new Date(a.closeDate) - new Date(b.closeDate);
                case 'amount':
                    return parseInt(b.amount.replace(/[₹,]/g, '')) - parseInt(a.amount.replace(/[₹,]/g, ''));
                case 'rating':
                    return b.rating - a.rating;
                case 'name':
                    return a.name.localeCompare(b.name);
                default:
                    return 0;
            }
        });

        setFilteredScholarships(filtered);
    }, [scholarships, searchTerm, selectedCategory, selectedClass, selectedAmount, sortBy, tabValue, appliedScholarships, bookmarkedScholarships]);

    const getStatusChip = (scholarship) => {
        const daysRemaining = getDaysRemaining(scholarship.closeDate);
        if (scholarship.status === 'expired' || daysRemaining < 0) {
            return <Chip label="Expired" color="error" size="small"/>;
        }
        if (daysRemaining < 30) {
            return <Chip label={`${daysRemaining} days left`} color="warning" size="small"/>;
        }
        return <Chip label="Active" color="success" size="small"/>;
    };

    const getCategoryIcon = (category) => {
        const icons = {
            class: <School/>,
            central: <AccountBalance/>,
            state: <LocationOn/>,
            community: <Group/>,
            private: <Business/>,
            sports: <EmojiEvents/>,
            arts: <Star/>
        };
        return icons[category] || <School/>;
    };

    const isApplicationDeadlinePassed = (closeDate) => {
        return new Date(closeDate) < new Date();
    };

    const getDaysRemaining = (closeDate) => {
        const today = new Date();
        const deadline = new Date(closeDate);
        return Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));
    };

    const handleApplyClick = (scholarship) => {
        if (appliedScholarships.has(scholarship.id)) {
            setSnackbar({open: true, message: 'You have already applied for this scholarship', severity: 'info'});
            return;
        }

        if (isApplicationDeadlinePassed(scholarship.closeDate)) {
            setSnackbar({open: true, message: 'Application deadline has passed', severity: 'error'});
            return;
        }

        setSelectedScholarship(scholarship);
        setApplicationDialog(true);
        setApplicationStep(0);
        setApplicationData({
            studentName: userDetails.name || '',
            studentId: userDetails.id || '',
            class: userDetails.class || '',
            parentIncome: '',
            reason: '',
            documents: [],
            guardianName: '',
            guardianPhone: '',
            guardianEmail: '',
            address: '',
            previousScholarships: '',
            achievements: '',
            financialNeed: ''
        });
    };

    const handleViewDetails = (scholarship) => {
        setSelectedScholarship(scholarship);
        setDetailsView(true);
    };

    const handleQuickApply = () => {
        const eligibleScholarships = filteredScholarships.filter(s =>
            !isApplicationDeadlinePassed(s.closeDate) &&
            !appliedScholarships.has(s.id) &&
            (s.class === 'all' || s.class.includes(userDetails.class))
        );

        if (eligibleScholarships.length > 0) {
            setQuickApplyDialog(true);
        } else {
            setSnackbar({
                open: true,
                message: 'No eligible scholarships available for quick apply',
                severity: 'info'
            });
        }
    };

    const handleBookmark = (scholarshipId) => {
        setBookmarkedScholarships(prev => {
            const newSet = new Set(prev);
            if (newSet.has(scholarshipId)) {
                newSet.delete(scholarshipId);
                setSnackbar({
                    open: true,
                    message: 'Removed from bookmarks',
                    severity: 'info'
                });
            } else {
                newSet.add(scholarshipId);
                setSnackbar({
                    open: true,
                    message: 'Added to bookmarks',
                    severity: 'success'
                });
            }
            return newSet;
        });
    };

    const handleApplicationSubmit = () => {
        if (!applicationData.studentName || !applicationData.class || !applicationData.reason) {
            setSnackbar({open: true, message: 'Please fill all required fields', severity: 'error'});
            return;
        }

        setUploadProgress(0);
        const interval = setInterval(() => {
            setUploadProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 10;
            });
        }, 200);

        setTimeout(() => {
            setAppliedScholarships(prev => new Set([...prev, selectedScholarship.id]));
            setApplicationDialog(false);
            setSnackbar({
                open: true,
                message: `Application submitted successfully for ${selectedScholarship.name}!`,
                severity: 'success'
            });
            setUploadProgress(0);
        }, 2000);
    };

    const handleInputChange = (field, value) => {
        setApplicationData(prev => ({...prev, [field]: value}));
    };

    const renderApplicationStepContent = (step) => {
        // ... (existing renderApplicationStep logic)
    };

    const renderScholarshipCard = (scholarship) => {
        const isExpired = isApplicationDeadlinePassed(scholarship.closeDate);
        const isApplied = appliedScholarships.has(scholarship.id);
        const isBookmarked = bookmarkedScholarships.has(scholarship.id);

        return (
            <Card sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                borderRadius: 3,
                boxShadow: 3,
                transition: '0.3s',
                '&:hover': {transform: 'translateY(-5px)', boxShadow: 6}
            }}>
                <CardHeader
                    avatar={<Avatar sx={{bgcolor: 'primary.main'}}>{getCategoryIcon(scholarship.category)}</Avatar>}
                    action={
                        <IconButton onClick={() => handleBookmark(scholarship.id)}>
                            {isBookmarked ? <Bookmark color="primary"/> : <BookmarkBorder/>}
                        </IconButton>
                    }
                    title={<Typography variant="h6" fontWeight="bold">{scholarship.name}</Typography>}
                    subheader={<Typography variant="body2" color="text.secondary">{scholarship.provider}</Typography>}
                />
                <CardContent sx={{flexGrow: 1}}>
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
                        <Typography variant="h5" color="primary" fontWeight="bold">{scholarship.amount}</Typography>
                        {getStatusChip(scholarship)}
                    </Box>
                    <Typography variant="body2" color="text.secondary"
                                sx={{mb: 2, height: 60, overflow: 'hidden'}}>{scholarship.description}</Typography>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Rating value={scholarship.rating} readOnly size="small"/>
                        <Typography variant="body2">{scholarship.applicants} Applicants</Typography>
                    </Box>
                </CardContent>
                <CardActions sx={{p: 2, justifyContent: 'space-between'}}>
                    <Button
                        variant={isApplied ? "outlined" : "contained"}
                        onClick={() => handleApplyClick(scholarship)}
                        disabled={isExpired || isApplied}
                        startIcon={isApplied ? <CheckCircle/> : <Assignment/>}
                        color={isApplied ? "success" : "primary"}
                    >
                        {isApplied ? 'Applied' : 'Apply Now'}
                    </Button>
                    <Button variant="text" onClick={() => handleViewDetails(scholarship)}>View Details</Button>
                </CardActions>
            </Card>
        );
    };

    const renderScholarshipList = () => {
        // ... (existing renderListView logic)
    };

    const renderDetailsView = () => {
        if (!selectedScholarship) return null;
        const isExpired = isApplicationDeadlinePassed(selectedScholarship.closeDate);
        const isApplied = appliedScholarships.has(selectedScholarship.id);

        return (
            <Box>
                <Button startIcon={<ChevronLeft/>} onClick={() => setDetailsView(false)} sx={{mb: 2}}>
                    Back to Scholarships
                </Button>
                <Paper sx={{p: 4, borderRadius: 4}}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={8}>
                            <Typography variant="h4" fontWeight="bold"
                                        gutterBottom>{selectedScholarship.name}</Typography>
                            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                                Provided by: <strong>{selectedScholarship.provider}</strong>
                            </Typography>
                            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1, my: 2}}>
                                {getStatusChip(selectedScholarship)}
                                <Chip icon={<Apartment/>} label={selectedScholarship.type} size="small"/>
                                <Chip icon={<AttachMoney/>} label={selectedScholarship.amount} size="small"
                                      color="success"/>
                                <Chip icon={<Group/>} label={`${selectedScholarship.applicants} Applicants`}
                                      size="small"/>
                            </Box>
                            <Typography variant="h6" mt={3}>Description</Typography>
                            <Typography paragraph>{selectedScholarship.description}</Typography>
                            <Typography variant="h6" mt={3}>Eligibility</Typography>
                            <Typography paragraph>{selectedScholarship.eligibility}</Typography>
                            <Typography variant="h6" mt={3}>Requirements</Typography>
                            <List dense>
                                {selectedScholarship.requirements.map((req, i) => (
                                    <ListItem key={i}><ListItemIcon sx={{minWidth: 32}}><CheckCircle color="primary"
                                                                                                     fontSize="small"/></ListItemIcon><ListItemText
                                        primary={req}/></ListItem>
                                ))}
                            </List>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{borderRadius: 3}}>
                                <CardContent>
                                    <Typography variant="h6" align="center" gutterBottom>Application
                                        Details</Typography>
                                    <List>
                                        <ListItem><ListItemIcon><CalendarToday/></ListItemIcon><ListItemText
                                            primary="Opens" secondary={selectedScholarship.openDate}/></ListItem>
                                        <ListItem><ListItemIcon><CalendarToday
                                            color="error"/></ListItemIcon><ListItemText primary="Closes"
                                                                                        secondary={selectedScholarship.closeDate}/></ListItem>
                                        <ListItem><ListItemIcon><Info/></ListItemIcon><ListItemText primary="Contact"
                                                                                                    secondary={selectedScholarship.contact}/></ListItem>
                                    </List>
                                    <Button
                                        fullWidth
                                        variant={isApplied ? "outlined" : "contained"}
                                        onClick={() => handleApplyClick(selectedScholarship)}
                                        disabled={isExpired || isApplied}
                                        startIcon={isApplied ? <CheckCircle/> : <Assignment/>}
                                        color={isApplied ? "success" : "primary"}
                                        sx={{mt: 2}}
                                    >
                                        {isApplied ? 'Applied' : 'Apply Now'}
                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        );
    };

    const handleCreateScholarship = () => {
        // Basic validation
        if (!newScholarship.name || !newScholarship.amount || !newScholarship.closeDate) {
            setSnackbar({open: true, message: 'Please fill all required fields', severity: 'error'});
            return;
        }

        // Simulate API call
        setLoading(true);
        setTimeout(() => {
            setScholarships(prev => [...prev, {...newScholarship, id: prev.length + 1, applicants: 0, awarded: 0}]);
            setFilteredScholarships(prev => [...prev, {
                ...newScholarship,
                id: prev.length + 1,
                applicants: 0,
                awarded: 0
            }]);
            setCreateScholarshipDialog(false);
            setNewScholarship({
                name: '',
                category: 'class',
                type: 'Class-based',
                class: '',
                amount: '',
                eligibility: '',
                openDate: '',
                closeDate: '',
                description: '',
                provider: '',
                requirements: [''],
                status: 'active',
                rating: 4.5,
                applicants: 0,
                awarded: 0,
                trending: false,
                featured: false,
                contact: ''
            });
            setSnackbar({open: true, message: 'Scholarship created successfully', severity: 'success'});
            setLoading(false);
        }, 1500);
    };

    const handleAdminAction = (action, scholarshipId) => {
        if (action === 'view') {
            const scholarship = scholarships.find(s => s.id === scholarshipId);
            setSelectedScholarship(scholarship);
            setApplicationDialog(true);
            setApplicationStep(0);
            setApplicationData({
                studentName: userDetails.name || '',
                studentId: userDetails.id || '',
                class: userDetails.class || '',
                parentIncome: '',
                reason: '',
                documents: [],
                guardianName: '',
                guardianPhone: '',
                guardianEmail: '',
                address: '',
                previousScholarships: '',
                achievements: '',
                financialNeed: ''
            });
        } else if (action === 'edit') {
            const scholarship = scholarships.find(s => s.id === scholarshipId);
            setNewScholarship({...scholarship});
            setCreateScholarshipDialog(true);
        } else if (action === 'delete') {
            setScholarships(prev => prev.filter(s => s.id !== scholarshipId));
            setFilteredScholarships(prev => prev.filter(s => s.id !== scholarshipId));
            setSnackbar({open: true, message: 'Scholarship deleted successfully', severity: 'success'});
        }
    };

    if (detailsView) {
        return (
            <Container maxWidth="lg" sx={{py: 4}}>
                {renderDetailsView()}
            </Container>
        );
    }

    return (
        <Container maxWidth="xl" sx={{py: 4}}>
            <Box sx={{display: 'flex', alignItems: 'center', mb: 4, flexDirection: isMobile ? 'column' : 'row'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <EmojiEvents color="primary" sx={{fontSize: 40, mr: 2}}/>
                    <Typography variant={isMobile ? "h4" : "h3"} component="h1" fontWeight="bold">
                        Scholarships
                    </Typography>
                </Box>
                <Box sx={{ml: 'auto', display: 'flex', gap: 1, mt: isMobile ? 2 : 0}}>
                    <Button variant="contained" startIcon={<Add/>} onClick={handleQuickApply} color="secondary">
                        Quick Apply
                    </Button>
                    <IconButton onClick={fetchScholarships} color="primary"><Refresh/></IconButton>
                    <IconButton onClick={() => setViewMode(viewMode === 'grid' ? 'list' : 'grid')}>
                        {viewMode === 'grid' ? <ViewList/> : <GridView/>}
                    </IconButton>
                </Box>
            </Box>

            <Grid container spacing={2} sx={{mb: 3}}>
                {/* ... (existing quick stats) */}
            </Grid>

            <Paper sx={{mb: 3, borderRadius: 3}}>
                <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} variant="scrollable"
                      scrollButtons="auto">
                    <Tab label="All Scholarships"/>
                    <Tab label="Featured"/>
                    <Tab label="Trending"/>
                    <Tab label="Applied"/>
                    <Tab label="Bookmarked"/>
                </Tabs>
            </Paper>

            <Paper sx={{p: 2, mb: 3, borderRadius: 3}}>
                <Box sx={{display: 'flex', alignItems: 'center', mb: showFilters ? 2 : 0}}>
                    <FilterAlt sx={{mr: 1}}/>
                    <Typography variant="h6">Filters</Typography>
                    <IconButton onClick={() => setShowFilters(!showFilters)} sx={{ml: 'auto'}}>
                        {showFilters ? <ExpandLess/> : <ExpandMore/>}
                    </IconButton>
                </Box>
                <Collapse in={showFilters}>
                    {/* ... (existing filters) */}
                </Collapse>
            </Paper>

            <Box sx={{mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography variant="h6">
                    {loading ? 'Loading scholarships...' : `Showing ${filteredScholarships.length} scholarships`}
                </Typography>
                {isAdmin && (
                    <Button variant="contained" startIcon={<Add/>} onClick={() => setCreateScholarshipDialog(true)}
                            color="primary">
                        Create Scholarship
                    </Button>
                )}
            </Box>

            {loading ? (
                <Grid container spacing={3}>
                    {[...Array(6)].map((_, i) => (
                        <Grid item xs={12} md={6} lg={4} key={i}>
                            <Skeleton variant="rectangular" height={250} sx={{borderRadius: 3}}/>
                        </Grid>
                    ))}
                </Grid>
            ) : filteredScholarships.length === 0 ? (
                <Alert severity="info">No scholarships found matching your criteria. Try adjusting your filters.</Alert>
            ) : viewMode === 'grid' ? (
                <Grid container spacing={3}>
                    {filteredScholarships.map((s) => (
                        <Grid item xs={12} md={6} lg={4} key={s.id}>{renderScholarshipCard(s)}</Grid>
                    ))}
                </Grid>
            ) : (
                renderScholarshipList()
            )}

            <Dialog open={applicationDialog} onClose={() => setApplicationDialog(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    Apply for {selectedScholarship?.name}
                    <Stepper activeStep={applicationStep} alternativeLabel sx={{pt: 3}} connector={<QontoConnector/>}>
                        {applicationSteps.map(step => (
                            <Step key={step.label}><StepLabel>{step.label}</StepLabel></Step>
                        ))}
                    </Stepper>
                </DialogTitle>
                <DialogContent>
                    {renderApplicationStepContent(applicationStep)}
                    {applicationStep === 3 && uploadProgress > 0 && (
                        <Box sx={{mt: 2}}>
                            <LinearProgress variant="determinate" value={uploadProgress}/>
                            <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
                                Uploading... {uploadProgress}%
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setApplicationDialog(false)}>Cancel</Button>
                    {applicationStep > 0 &&
                        <Button onClick={() => setApplicationStep(prev => prev - 1)}>Previous</Button>}
                    {applicationStep < applicationSteps.length - 1 ? (
                        <Button onClick={() => setApplicationStep(prev => prev + 1)} variant="contained">Next</Button>
                    ) : (
                        <Button onClick={handleApplicationSubmit} variant="contained" color="success">Submit
                            Application</Button>
                    )}
                </DialogActions>
            </Dialog>

            <Dialog open={createScholarshipDialog} onClose={() => setCreateScholarshipDialog(false)} maxWidth="md"
                    fullWidth>
                <DialogTitle>
                    {newScholarship.id ? 'Edit Scholarship' : 'Create New Scholarship'}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="Scholarship Name"
                                value={newScholarship.name}
                                onChange={(e) => setNewScholarship({...newScholarship, name: e.target.value})}
                                fullWidth
                                required
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Category</InputLabel>
                                <Select
                                    value={newScholarship.category}
                                    onChange={(e) => setNewScholarship({...newScholarship, category: e.target.value})}
                                    label="Category"
                                >
                                    <MenuItem value="class">Class-based</MenuItem>
                                    <MenuItem value="central">Central Government</MenuItem>
                                    <MenuItem value="state">State/Regional</MenuItem>
                                    <MenuItem value="community">Community-based</MenuItem>
                                    <MenuItem value="private">Private</MenuItem>
                                    <MenuItem value="sports">Sports</MenuItem>
                                    <MenuItem value="arts">Arts & Culture</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Type</InputLabel>
                                <Select
                                    value={newScholarship.type}
                                    onChange={(e) => setNewScholarship({...newScholarship, type: e.target.value})}
                                    label="Type"
                                >
                                    <MenuItem value="Class-based">Class-based</MenuItem>
                                    <MenuItem value="Central Government">Central Government</MenuItem>
                                    <MenuItem value="State/Regional">State/Regional</MenuItem>
                                    <MenuItem value="Community-based">Community-based</MenuItem>
                                    <MenuItem value="Private">Private</MenuItem>
                                    <MenuItem value="Merit-based">Merit-based</MenuItem>
                                    <MenuItem value="Need-based">Need-based</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Amount"
                                value={newScholarship.amount}
                                onChange={(e) => setNewScholarship({...newScholarship, amount: e.target.value})}
                                fullWidth
                                required
                                margin="normal"
                                placeholder="₹10,000"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Applicable Classes</InputLabel>
                                <Select
                                    multiple
                                    value={newScholarship.class ? newScholarship.class.split(',') : []}
                                    onChange={(e) => setNewScholarship({
                                        ...newScholarship,
                                        class: e.target.value.join(',')
                                    })}
                                    label="Applicable Classes"
                                >
                                    {classOptions.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Open Date"
                                type="date"
                                value={newScholarship.openDate}
                                onChange={(e) => setNewScholarship({...newScholarship, openDate: e.target.value})}
                                fullWidth
                                required
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Close Date"
                                type="date"
                                value={newScholarship.closeDate}
                                onChange={(e) => setNewScholarship({...newScholarship, closeDate: e.target.value})}
                                fullWidth
                                required
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Provider"
                                value={newScholarship.provider}
                                onChange={(e) => setNewScholarship({...newScholarship, provider: e.target.value})}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Eligibility Criteria"
                                value={newScholarship.eligibility}
                                onChange={(e) => setNewScholarship({...newScholarship, eligibility: e.target.value})}
                                fullWidth
                                multiline
                                rows={2}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Description"
                                value={newScholarship.description}
                                onChange={(e) => setNewScholarship({...newScholarship, description: e.target.value})}
                                fullWidth
                                multiline
                                rows={3}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Contact"
                                value={newScholarship.contact}
                                onChange={(e) => setNewScholarship({...newScholarship, contact: e.target.value})}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>Requirements</Typography>
                            {newScholarship.requirements.map((req, index) => (
                                <Box key={index} sx={{display: 'flex', gap: 1, mb: 1}}>
                                    <TextField
                                        value={req}
                                        onChange={(e) => {
                                            const newReqs = [...newScholarship.requirements];
                                            newReqs[index] = e.target.value;
                                            setNewScholarship({...newScholarship, requirements: newReqs});
                                        }}
                                        fullWidth
                                        placeholder={`Requirement ${index + 1}`}
                                    />
                                    <IconButton
                                        onClick={() => {
                                            const newReqs = newScholarship.requirements.filter((_, i) => i !== index);
                                            setNewScholarship({...newScholarship, requirements: newReqs});
                                        }}
                                        color="error"
                                    >
                                        <DeleteIcon/>
                                    </IconButton>
                                </Box>
                            ))}
                            <Button
                                startIcon={<Add/>}
                                onClick={() => {
                                    setNewScholarship({
                                        ...newScholarship,
                                        requirements: [...newScholarship.requirements, '']
                                    });
                                }}
                            >
                                Add Requirement
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={newScholarship.featured}
                                        onChange={(e) => setNewScholarship({
                                            ...newScholarship,
                                            featured: e.target.checked
                                        })}
                                    />
                                }
                                label="Mark as Featured"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={newScholarship.trending}
                                        onChange={(e) => setNewScholarship({
                                            ...newScholarship,
                                            trending: e.target.checked
                                        })}
                                    />
                                }
                                label="Mark as Trending"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCreateScholarshipDialog(false)}>Cancel</Button>
                    <Button onClick={handleCreateScholarship} variant="contained" color="primary">
                        {newScholarship.id ? 'Update Scholarship' : 'Create Scholarship'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Admin Applications Review Dialog */}
            {isAdmin && (
                <Dialog open={applicationDialog} onClose={() => setApplicationDialog(false)} maxWidth="md" fullWidth>
                    <DialogTitle>
                        Review Application
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="h6" gutterBottom>
                            Student Details
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">Name: {applicationData.studentName}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">ID: {applicationData.studentId}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">Class: {applicationData.class}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle1">Parent
                                    Income: {applicationData.parentIncome}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1">Reason for Application:</Typography>
                                <Paper sx={{p: 2, bgcolor: 'background.default'}}>
                                    <Typography>{applicationData.reason || 'No reason provided'}</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1">Guardian Details:</Typography>
                                <Typography variant="body2">Name: {applicationData.guardianName}</Typography>
                                <Typography variant="body2">Phone: {applicationData.guardianPhone}</Typography>
                                <Typography variant="body2">Email: {applicationData.guardianEmail}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1">Financial Need:</Typography>
                                <Paper sx={{p: 2, bgcolor: 'background.default'}}>
                                    <Typography>{applicationData.financialNeed || 'No information provided'}</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1">Documents:</Typography>
                                <List>
                                    {applicationData.documents.length > 0 ? (
                                        applicationData.documents.map((doc, index) => (
                                            <ListItem key={index}>
                                                <ListItemIcon>
                                                    <Description/>
                                                </ListItemIcon>
                                                <ListItemText primary={doc}/>
                                            </ListItem>
                                        ))
                                    ) : (
                                        <ListItem>
                                            <ListItemText primary="No documents uploaded"/>
                                        </ListItem>
                                    )}
                                </List>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setApplicationDialog(false)}>Close</Button>
                        <Button
                            onClick={() => {
                                setApplicationDialog(false);
                                setSnackbar({
                                    open: true,
                                    message: 'Application approved successfully!',
                                    severity: 'success'
                                });
                            }}
                            variant="contained"
                            color="success"
                        >
                            Approve
                        </Button>
                        <Button
                            onClick={() => {
                                setApplicationDialog(false);
                                setSnackbar({
                                    open: true,
                                    message: 'Application rejected',
                                    severity: 'error'
                                });
                            }}
                            variant="contained"
                            color="error"
                        >
                            Reject
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({...snackbar, open: false})}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            >
                <Alert onClose={() => setSnackbar({...snackbar, open: false})} severity={snackbar.severity}
                       sx={{width: '100%'}}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* Toggle Button for Admin/Student View */}
            <Fab
                color={isAdmin ? "secondary" : "primary"}
                sx={{position: 'fixed', bottom: 16, right: 16}}
                onClick={() => isAdmin ? handleQuickApply() : setCreateScholarshipDialog(true)}
            >
                <Add/>
            </Fab>

            {/* Admin/Student Toggle */}
            <Fab
                color="default"
                size="small"
                sx={{position: 'fixed', bottom: 90, right: 16}}
                onClick={() => setIsAdmin(!isAdmin)}
            >
                {isAdmin ? <School/> : <Assignment/>}
            </Fab>
        </Container>
    );
};

export default ScholarShip;
